import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import logo from "../../assets/img/profileLogo.png";
import loginBg from "../../assets/img/login_bg.png";

import CustomTextField from "components/UpdateUi/CustomeTextField";

import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";

import { useSelector } from "react-redux";

import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import ToastModal from "views/components/ToastModal";
import brandTheme from "brandTheme/Theme";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
  height: "calc(100% - 85px)",
    // minHeight: "100vh",

    backgroundImage: `
      linear-gradient(
        rgba(43,0,19,0.25),
        rgba(91,0,44,0.25)
      ),
      url(${loginBg})
    `,

    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",

    padding: "40px",

    alignItems: "center",

    justifyContent: "space-between",

    overflow: "hidden",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      justifyContent: "center",
      // padding: "20px",
    },
  },

  // LEFT SECTION
  leftSection: {
    flex: 1,
    color: "#fff",
    padding: "40px 60px",

    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },

  leftTitle: {
    fontSize: "68px",
    fontWeight: 700,
    lineHeight: 1.1,
    marginBottom: "24px",
  },

  leftSubTitle: {
    fontSize: "20px",
    lineHeight: 1.8,
    maxWidth: "520px",
    color: "rgba(255,255,255,0.82)",
    marginBottom: "40px",
  },

  featureContainer: {
    marginTop: "40px",
  },

  featureItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "24px",

    "& span": {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      background: "rgba(255,255,255,0.12)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "16px",
      fontSize: "22px",
    },

    "& p": {
      fontSize: "18px",
      margin: 0,
    },
  },

  // RIGHT SECTION
  formWrapper: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  formBox: {
    width: "100%",
    maxWidth: "620px",

    background: "rgba(255,255,255,0.96)",

    borderRadius: "32px",

    padding: "50px 45px",

    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",

    [theme.breakpoints.down("sm")]: {
      padding: "35px 24px",
    },
  },

  logoContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "20px",
  },

  logo: {
    width: "100px",
    height: "100px",
    objectFit: "cover",
    borderRadius: "50%",
    border: `4px solid ${brandTheme.secondaryColor}`
  },

  textContainer: {
    textAlign: "center",
    marginBottom: "30px",
  },

  heading: {
    fontSize: "42px",
    fontWeight: 700,
    color: brandTheme.mainColor,
    marginBottom: "10px",

    [theme.breakpoints.down("sm")]: {
      fontSize: "34px",
    },
  },

  subHeading: {
    color: "#777",
    fontSize: "16px",
  },

  inputField: {
    width: "100%",
    marginBottom: "24px",
  },

  consentContainer: {
    marginTop: "20px",
  },

  consentLabel: {
    color: "#555",
    fontSize: "14px",
    lineHeight: 1.8,
  },

  checkBox: {
    color: `${brandTheme.mainColor} !important`,
  },

  linkText: {
    color: brandTheme.secondaryColor,
    fontWeight: 600,
    textDecoration: "underline",
  },

  button: {
    height: "58px",

    borderRadius: "14px",

    background:
      "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",

    color: "#fff",

    width: "100%",

    marginTop: "24px",

    fontWeight: 700,

    fontSize: "17px",

    textTransform: "none",

    boxShadow: "0 10px 24px rgba(91,0,44,0.22)",

    "&:hover": {
      background:
        "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    },
  },
}));

const PanDetailsVerification = () => {
  const classes = useStyles();

  const navigate = useNavigate();

  const [panNumber, setPanNumber] = useState("");

  const { authToken } = useSelector(
    (state) => state.login.authData
  );

  const { mobileNumber } = useSelector(
    (state) => state.login.userData
  );

  const [callInProgress, setCallInProgress] =
    useState(false);

  const [consentCheck, setConsentCheck] =
    useState(true);

  const [consentCheck2, setConsentCheck2] =
    useState(true);

  const [toast, setToast] = useState(false);

  const [toastMessage, setToastMessage] =
    useState("");

  const [toastMessageType, setToastMessageType] =
    useState("");

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  const handleNext = async () => {
    setCallInProgress(true);

    const result = await apiHandler({
      url: endpoint.USER_UPDATE_PAN_CARD_API,
      method: "POST",
      authToken: authToken,

      data: {
        mobileNumber: mobileNumber,
        panNumber: panNumber.toUpperCase(),
      },
    });

    setCallInProgress(false);

    if (result?.data?.error_code) {
      toastUpdate(
        "Error",
        result?.data?.user_description,
        true
      );
    } else {
      navigate("/Dashboard");
    }
  };

  return (
    <div className={classes.container}>
      {/* LEFT SECTION */}
      <div className={classes.leftSection}>
        <Typography className={classes.leftTitle}>
          Secure Your <br />
          PAN Verification
        </Typography>

        <Typography className={classes.leftSubTitle}>
          Help us verify your PAN details securely
          and continue your instant loan journey
          with a premium onboarding experience.
        </Typography>

        <div className={classes.featureContainer}>
          <div className={classes.featureItem}>
            <span>🛡️</span>
            <p>100% Secure</p>
          </div>

          <div className={classes.featureItem}>
            <span>⚡</span>
            <p>Instant Verification</p>
          </div>

          <div className={classes.featureItem}>
            <span>₹</span>
            <p>Safe & Encrypted</p>
          </div>
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className={classes.formWrapper}>
        <div className={classes.formBox}>
          <div className={classes.logoContainer}>
            <img
              src={logo}
              alt="Logo"
              className={classes.logo}
            />
          </div>

          <div className={classes.textContainer}>
            <Typography className={classes.heading}>
              Help Us Identify You...
            </Typography>

            <Typography className={classes.subHeading}>
              Please let us know your PAN.
            </Typography>
          </div>

          <CustomTextField
            label="PAN Number"
            placeholder="Enter PAN Number"
            value={panNumber}
            onChange={(e) =>
              setPanNumber(
                e.target.value.toUpperCase()
              )
            }
            style={classes.inputField}
            maxLength={10}
          />

          <div className={classes.consentContainer}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={consentCheck}
                  onChange={(e) =>
                    setConsentCheck(
                      e.target.checked
                    )
                  }
                  className={classes.checkBox}
                />
              }
              label={
                <Typography
                  className={classes.consentLabel}
                >
                  I confirm the above PAN belongs
                  to me. I authorize the lender on
                  personal loan App to pull my
                  records from CKYC, run credit
                  checks on my behalf and share the
                  report with lending partners.
                </Typography>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={consentCheck2}
                  onChange={(e) =>
                    setConsentCheck2(
                      e.target.checked
                    )
                  }
                  className={classes.checkBox}
                />
              }
              label={
                <Typography
                  className={classes.consentLabel}
                >
                  By continuing, I agree to CIBIL{" "}
                  <a
                    href="/term-and-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.linkText}
                  >
                    Terms and Conditions
                  </a>{" "}
                  and authorize the personal loan
                  provider to run a CIBIL check for
                  my profile.
                </Typography>
              }
            />
          </div>

          <Button
            className={classes.button}
            onClick={handleNext}
            disabled={
              panNumber.length !== 10 ||
              !consentCheck2 ||
              !consentCheck
            }
          >
            Continue
          </Button>

          {callInProgress && (
            <CircularProgresss
              callInProgress={callInProgress}
            />
          )}

          {toast && (
            <ToastModal
              toastMessage={toastMessage}
              toastMessageType={toastMessageType}
              toastUpdate={toastUpdate}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PanDetailsVerification;